import React from "react";
import ReactDOM from "react-dom/client";
import 'leaflet/dist/leaflet.css';
import "@/index.css";
import App from "@/App";
import * as serviceWorkerRegistration from './utils/serviceWorkerRegistration';

(() => {
  try {
    const { pathname, hash, origin } = window.location;
    if (pathname === "/" && hash) {
      const raw = hash.startsWith("#") ? hash.slice(1) : hash;
      const params = new URLSearchParams(raw);
      const type = params.get("type");
      const accessToken = params.get("access_token");
      if (type === "recovery" && accessToken) {
        window.location.replace(`${origin}/sifre-sifirla${hash}`);
      }
    }
  } catch (e) {
    // ignore
  }
})();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Unregister service worker to prevent cache issues
serviceWorkerRegistration.unregister();
